<!--
검수요청 메세지 확인
-->
<template>
    <div class="uk-flex-top" uk-modal>
        <div class="uk-modal-dialog uk-margin-auto-vertical">

            <div class="uk-modal-header uk-text-center uk-text-large">
                검수요청 메세지
            </div>

            <div class="uk-modal-body uk-text-large app-color-black">
                <ul class="uk-list uk-list-bullet">
                    <li
                        v-for="(request) in requests"
                        :key="request.id"
                        v-nl2br="request.request"
                    >
                    </li>
                </ul>

            </div>


            <div class="uk-modal-footer uk-text-center">
                <!--- 버튼 -->
                <button
                    type="button"
                    class="uk-button uk-button-default uk-modal-close uk-button-large"
                >
                    <span uk-icon="icon: close"></span> 확인
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            // 검수요청 배열
            requests: Array,
        },
        data: function () {
            return {
            };
        },
        computed: {
        },
        methods: {
            /**
             * 입력폼 display
             */
            show() {
                UIkit.modal(this.$el).show();
            },
        },
    }
</script>

<style lang="scss" scoped>
</style>